
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"manage-subscription\" class=\"settings-unit\">\n  <div class=\"settings-unit-stub\">\n    <header class=\"settings-unit-summary\">\n      <h2 class=\"settings-unit-title\">{{#t}}Subscriptions & Payments{{/t}}</h2>\n    </header>\n    <button class=\"settings-button primary-button settings-unit-toggle\">\n      <span class=\"change-button\">{{#t}}Manage…{{/t}}</span>\n    </button>\n  </div>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  